<template>
  <div class="customers">
    <CurrVersions />
    <h1>Customers</h1>
    <div class="table-wrapper loader-container">
      <vue-good-table
        :columns="[
          {
            label: 'Customer Name',
            field: 'customerName'
          },
          {
            label: 'Type',
            field: 'type',
            filterOptions: {
              enabled: true,
              placeholder: 'Select',
              filterDropdownItems: ['LIVE', 'TEST', 'INACTIVE'],
              filterValue: 'LIVE'
            }
          },
          {
            label: 'Target Version',
            field: 'targetVersion',
            filterOptions: {
              enabled: true,
              placeholder: 'Select',
              filterDropdownItems: ['Alpha', 'Beta', 'Release', 'Stable']
            }
          },
          {
            label: 'Current Version',
            field: 'currentVersion',
            sortFn: this.sortVersion
          }
        ]"
        :rows="customers"
        ><template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'customerName'">
            <router-link
              :to="{
                name: 'Customer',
                params: { customerId: props.row.customerId }
              }"
              >{{ props.row.customerName }}
            </router-link>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template></vue-good-table
      >
      <Loader :loading="loadingCustomers" />
    </div>
  </div>
</template>

<script>
import service from "@/services/service.js";
import Loader from "@/components/Loader.vue";
import CurrVersions from "@/components/CurrVersions.vue";
import { VueGoodTable } from "vue-good-table";

export default {
  components: { Loader, CurrVersions, VueGoodTable },
  data() {
    return {
      customers: [],
      loadingCustomers: false
    };
  },
  created() {
    this.getCustomers();
  },
  methods: {
    getCustomers() {
      var self = this;
      self.loadingCustomers = true;
      service
        .getCustomers()
        .then(response => {
          self.customers = response.data;
          self.loadingCustomers = false;
        })
        .catch(() => {
          self.loadingCustomers = false;
        });
    }
  }
};
</script>
